export default __webpack_public_path__ + "static/media/3.24d5c350.jpg";